import React from 'react';
import Sidebar from 'common/Sidebar'

import coachinfo from 'style/coachinfo.png'

function CoachInfo(props) {
    return (
        <div className="container">
            <div className="row ">
                <div className="d-none d-xl-block col-3 px-0">
                    <Sidebar root={'/coachInfo'} title={'코치과정안내'} />
                </div>
                <div className="col-12 col-xl-9 px-0" >
                    <img src={coachinfo} alt="코치과정안내" width="100%" />
                </div>
            </div>
        </div>
    );
}

export default CoachInfo;